import React, { FC } from 'react'

import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import Container from '@material-ui/core/Container'
import withSharedStyles from '../hooks/withSharedStyles'
import Section from '../components/web/Section'
import Link from '../components/widgets/Link'
import SquareImage from '../components/bowie/SquareImage'

import {
  getStorageUrl,
  STORAGE_URL_GODPIXEL,
} from '@shared/constants'

const Home: FC = ({

}) => {
  const classes = withSharedStyles()
    
  return (
    <div className={ classes.rootPage }>
      <Section padding className={ classes.centerText }>
        <Typography gutterBottom variant="h2" className={ classes.titleText }>
            pan-nft
        </Typography>
        <Typography gutterBottom variant="h6">
          valuing art and the artist in the metaverse
        </Typography>
      </Section>
      <Container maxWidth="md" className={ classes.homepageContainer }>
        <Grid container spacing={ 8 }>
          <Grid item xs={ 12 } sm={ 6 }>
            <Link name="bowie" className={ classes.noUnderline }>
              <img
                className={ classes.circleImage }
                style={{
                  width: '100%'
                }}
                src={getStorageUrl('website/assets/homepage/Bowie-on-the-Blockchain©Gavin-Evans.jpg')}
              />
            </Link>
          </Grid>
          <Grid item xs={ 12 } sm={ 6 }>
            <Link name="bowie" className={ classes.noUnderline }>
              <div style={{
                paddingTop: '50px'
              }}>
                <Typography gutterBottom variant="h2" className={ classes.titleText }>
                  Bowie on the Blockchain
                </Typography>
                <Typography gutterBottom variant="h6" className={ classes.noUnderline }>
                  the 1st ever photograph on the ethereum blockchain
                </Typography>
              </div>
            </Link>
          </Grid>
          <Grid item xs={ 12 } sm={ 6 }>
            <Link name="threetens_home" className={ classes.noUnderline }>
              <img
                className={ classes.circleImage }
                style={{
                  width: '100%'
                }}
                src={getStorageUrl('website/assets/homepage/101010-Homepage-Sq.jpg')}
              />
            </Link>
          </Grid>
          <Grid item xs={ 12 } sm={ 6 }>
            <Link name="threetens_home" className={ classes.noUnderline }>
              <div style={{
                paddingTop: '50px'
              }}>
                <Typography gutterBottom variant="h2" className={ classes.titleText }>
                  10 10 10
                </Typography>
                <Typography gutterBottom variant="h6" className={ classes.noUnderline }>
                  ten ten ten. 1000 unique nfts out of the flames
                </Typography>
              </div>
            </Link>
          </Grid>
          <Grid item xs={ 12 } sm={ 6 }>
            <Link name="godpixel_home" className={ classes.noUnderline }>
              <img
                className={ classes.circleImage }
                style={{
                  width: '100%'
                }}
                src={getStorageUrl('website/assets/homepage/Ai-Weiwei©Gavin-Evans.jpg')}
              />
            </Link>
          </Grid>
          <Grid item xs={ 12 } sm={ 6 }>
            <Link name="godpixel_home" className={ classes.noUnderline }>
              <div style={{
                paddingTop: '50px'
              }}>
                <Typography gutterBottom variant="h2" className={ classes.titleText }>
                  The Godpixel
                </Typography>
                <Typography gutterBottom variant="h6" className={ classes.noUnderline }>
                  the first metaversal portraits
                </Typography>
              </div>
            </Link>
          </Grid>
          <Grid item xs={ 12 } sm={ 6 }>
            <Link name="graven_home" className={ classes.noUnderline }>
              <img
                className={ classes.circleImage }
                style={{
                  width: '100%'
                }}
                src={getStorageUrl('website/assets/homepage/ODB-06©Gavin-Evans.jpg')}
              />
            </Link>
          </Grid>
          <Grid item xs={ 12 } sm={ 6 }>
            <Link name="graven_home" className={ classes.noUnderline }>
              <div style={{
                paddingTop: '50px'
              }}>
                <Typography gutterBottom variant="h2" className={ classes.titleText }>
                  Graven Images
                </Typography>
                <Typography gutterBottom variant="h6" className={ classes.noUnderline }>
                  mint your own nft
                </Typography>
              </div>
            </Link>
          </Grid>
        </Grid>
      </Container>
      
    </div>
  )
}

export default Home